import { OrderOwnerType } from "./order-owner-type-enum.model";

export class OrderUser {
    userLogin: string;
    userName: string;
    userEmail: string;
    orderUserTypeId: OrderOwnerType;
    userGuid: string;
}


